import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { cloneDeep, merge, set } from 'lodash';
import AutomationRulesTable from 'module/automation/components/Automation.Rule.Table';
import {
  hasIncompleteAutomationEffects,
  hasIncompleteAutomationExpressions,
} from 'module/automation/helpers/ruleHelpers';
import { createClaimAutomationSchema } from 'module/automation/schemas/ClaimAutomationSchema';
import { useClaimTypeProvider } from '../../../ClaimType.Hooks';

type Props = {
  data: Partial<Model.IClaimTypeAutomationRule>;
  claimTypeDataPoints?: Partial<Model.IClaimTypeDataPoint>[];
  onSave(data: Model.IClaimTypeAutomationRule): void;
  onCancel(): void;
};

export default function ClaimTypeAutomationRuleEditForm(props: Props) {
  const { lang } = getLocales();
  const { automationClaimStatuses, automationClaimJobStatuses } = useClaimTypeProvider();
  const schema = createClaimAutomationSchema({
    claimStatuses: automationClaimStatuses,
    claimJobStatuses: automationClaimJobStatuses,
    claimTypeDataPoints: props.claimTypeDataPoints,
  });

  return (
    <ModalForm<Model.IClaimTypeAutomationRule>
      subcomponents={merge(cloneDeep(ThemeModalFormDefault), {
        modal: {
          page: {
            style: {
              pageWrapper: {
                ['--modalWidth']: 'var(--sizeXXL) * 1.5',
              },
            },
          },
        },
      })}
      dependencyArray={[props.data]}
      title={lang.automationRules}
      default={props.data || {}}
      onCancel={props.onCancel}
      onSubmit={props.onSave}
      validation={(data, errors) => {
        if (!data.effects?.length) set(errors, 'effects._objectError', lang.required);
        if (hasIncompleteAutomationEffects(data, schema)) set(errors, 'effects._objectError', lang.required);
        if (!data.expressions?.length) set(errors, 'expressions._objectError', lang.required);
        if (hasIncompleteAutomationExpressions(data)) set(errors, 'expressions._objectError', lang.required);
      }}
      render={({ form }) => (
        <FormWrapper>
          <AutomationRulesTable<Model.IClaimTypeAutomationRule>
            value={[form.data as Model.IClaimTypeAutomationRule]}
            schema={schema}
            hideAddRule
            hideDeleteRule
            onChange={(rules) => form.update(rules[0] || {})}
          />
        </FormWrapper>
      )}
    />
  );
}
